import { Control, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import i18n from 'i18n';
import { FormLabel } from '../../form-label';
import LOCALS from 'commons/locals';
import { Input } from 'antd';

const FirstValuationShopRemark = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel className="self-start">
        {i18n.t(LOCALS.service_comments)}:
      </FormLabel>
      <Controller
        name={`productList.${index}.firstValuationShopRemark`}
        control={control}
        render={({ field }) => (
          <Input.TextArea
            {...field}
            placeholder={i18n.t(LOCALS.please_enter) || ''}
            maxLength={500}
            showCount
          />
        )}
      />
    </div>
  );
};

export default FirstValuationShopRemark;
